module.exports = __webpack_public_path__ + "fonts/FuturaPT-Bold.91082c8d.woff2";